import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
// eslint-disable-next-line max-len
import { DocumentModerationFilterStatusListItem } from '@/models/dictionary/document-moderation-filter-status-list.model';

export default class GetDocumentModerationFilterStatusListRequest
  extends ApiResourceMethod<DocumentModerationFilterStatusListItem[]> {
  public perform(whitelabelSlug: string): Promise<DocumentModerationFilterStatusListItem[]> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/dictionary/documentModerationFilterStatusList`,
      },
      ({ data }: BaseResponse<DocumentModerationFilterStatusListItem[]>): DocumentModerationFilterStatusListItem[] =>
        data,
    );
  }
}
